import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllItems, deleteItem } from "./PlannerService";

export default function PlannerList(){
  const [items,setItems] = useState([]);
  const nav = useNavigate();

  useEffect(()=>{ load(); },[]);

  const load = async ()=>{
    const data = await getAllItems();
    setItems(data);
  };

  return (
    <div>
      <h2>Planner</h2>

      <button onClick={()=>nav("new")}>➕ Add</button>

      <table>
        <thead>
          <tr>
            <th>Title</th>
            <th>Type</th>
            <th>Due</th>
            <th>Priority</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {items.map(i=> (
            <tr key={i.id}>
              <td>{i.title}</td>
              <td>{i.type}</td>
              <td>{i.dueDate || i.eventDate || i.paymentDate}</td>
              <td>{i.priority}</td>
              <td>{i.status}</td>
              <td>
                {/* ✅ RELATIVE ROUTING */}
                <button onClick={()=>nav(`edit/${i.id}`)}>✏️</button>
                <button onClick={async()=>{ await deleteItem(i.id); load(); }}>🗑️</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
